/* React Native's global `btoa`/`atob` exist on modern Hermes but have edge cases */
/* with binary data (they assume Latin-1). For audio PCM we want a pure Uint8Array */
/* path. These helpers stay agnostic of `Buffer` (Node) and `atob/btoa` (web). */

const B64_ALPHABET =
  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

export function uint8ToBase64(bytes: Uint8Array): string {
  let out = '';
  let i = 0;
  const len = bytes.length;
  for (; i + 2 < len; i += 3) {
    const b0 = bytes[i]!;
    const b1 = bytes[i + 1]!;
    const b2 = bytes[i + 2]!;
    out += B64_ALPHABET[b0 >> 2];
    out += B64_ALPHABET[((b0 & 0x03) << 4) | (b1 >> 4)];
    out += B64_ALPHABET[((b1 & 0x0f) << 2) | (b2 >> 6)];
    out += B64_ALPHABET[b2 & 0x3f];
  }
  const rem = len - i;
  if (rem === 1) {
    const b0 = bytes[i]!;
    out += B64_ALPHABET[b0 >> 2];
    out += B64_ALPHABET[(b0 & 0x03) << 4];
    out += '==';
  } else if (rem === 2) {
    const b0 = bytes[i]!;
    const b1 = bytes[i + 1]!;
    out += B64_ALPHABET[b0 >> 2];
    out += B64_ALPHABET[((b0 & 0x03) << 4) | (b1 >> 4)];
    out += B64_ALPHABET[(b1 & 0x0f) << 2];
    out += '=';
  }
  return out;
}

const B64_LOOKUP = new Int16Array(128).fill(-1);
for (let i = 0; i < B64_ALPHABET.length; i++) {
  B64_LOOKUP[B64_ALPHABET.charCodeAt(i)] = i;
}

export function base64ToUint8(b64: string): Uint8Array {
  /* Strip whitespace; tolerate URL-safe variants. */
  const cleaned = b64.replace(/[^A-Za-z0-9+/=_-]/g, '').replace(/-/g, '+').replace(/_/g, '/');
  const padLen = cleaned.endsWith('==') ? 2 : cleaned.endsWith('=') ? 1 : 0;
  const byteLen = (cleaned.length / 4) * 3 - padLen;
  const out = new Uint8Array(byteLen);
  let p = 0;
  for (let i = 0; i < cleaned.length; i += 4) {
    const c0 = B64_LOOKUP[cleaned.charCodeAt(i)]!;
    const c1 = B64_LOOKUP[cleaned.charCodeAt(i + 1)]!;
    const c2 = B64_LOOKUP[cleaned.charCodeAt(i + 2)]!;
    const c3 = B64_LOOKUP[cleaned.charCodeAt(i + 3)]!;
    if (p < byteLen) out[p++] = (c0 << 2) | (c1 >> 4);
    if (p < byteLen) out[p++] = ((c1 & 0x0f) << 4) | (c2 >> 2);
    if (p < byteLen) out[p++] = ((c2 & 0x03) << 6) | c3;
  }
  return out;
}
